import React, { useState, useEffect } from "react";
import axios from "../api/api";
import LocationSelector from "../components/LocationSelector";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import "./AddressBook.css";

const AddressBook = ({ customerId }) => {
    const [addresses, setAddresses] = useState([]);
    const [newAddress, setNewAddress] = useState({
        title: "",
        detailedAddress: "",
        provinceId: "",
        districtId: "",
        wardId: "",
    });
    const [showModal, setShowModal] = useState(false); // Modal visibility
    const [editingAddressId, setEditingAddressId] = useState(null);

    // Fetch addresses on mount
    useEffect(() => {
        const fetchAddresses = async () => {
            try {
                const response = await axios.get(`/customer-profile/${customerId}/addresses`);
                setAddresses(response.data);
            } catch (error) {
                console.error("Error fetching addresses:", error);
            }
        };

        fetchAddresses();
    }, [customerId]);

    // Open the modal for adding or editing
    const handleOpenModal = (address = null) => {
        if (address) {
            setNewAddress({
                title: address.title,
                detailedAddress: address.detailedAddress,
                provinceId: address.provinceId?._id || "",
                districtId: address.districtId?._id || "",
                wardId: address.wardId?._id || "",
            });
            setEditingAddressId(address._id);
        } else {
            setNewAddress({
                title: "",
                detailedAddress: "",
                provinceId: "",
                districtId: "",
                wardId: "",
            });
            setEditingAddressId(null);
        }
        setShowModal(true);
    };

    // Close the modal
    const handleCloseModal = () => {
        setShowModal(false);
    };

    // Handle input change for address
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewAddress((prev) => ({ ...prev, [name]: value }));
    };

    // Handle save address (add or update)
    const handleSaveAddress = async () => {
        try {
            if (editingAddressId) {
                // Update existing address
                const response = await axios.put(
                    `/customer-profile/${customerId}/addresses/${editingAddressId}`,
                    newAddress
                );
                setAddresses(response.data.addresses);
                alert("Địa chỉ đã được cập nhật.");
            } else {
                // Add new address
                const response = await axios.post(
                    `/customer-profile/${customerId}/addresses`,
                    newAddress
                );
                setAddresses(response.data.addresses);
                alert("Địa chỉ đã được thêm thành công.");
            }
            handleCloseModal();
        } catch (error) {
            console.error("Error saving address:", error);
        }
    };

    // Handle deleting an address
    const handleDeleteAddress = async (addressId) => {
        try {
            const response = await axios.delete(
                `/customer-profile/${customerId}/addresses/${addressId}`
            );
            setAddresses(response.data.addresses);
            alert("Địa chỉ đã được xóa thành công.");
        } catch (error) {
            console.error("Error deleting address:", error);
        }
    };

    // Handle setting an address as default
    const handleSetDefaultAddress = async (addressId) => {
        try {
            const response = await axios.put(
                `/customer-profile/${customerId}/addresses/${addressId}/set-default`
            );
            setAddresses(response.data.addresses);
            alert("Địa chỉ mặc định đã được cập nhật.");
        } catch (error) {
            console.error("Error setting default address:", error);
        }
    };

    return (
        <div className="address-book">
            <h2>Sổ Địa Chỉ</h2>

            <div className="address-list">
                {addresses.map((address) => (
                    <div key={address._id} className="address-item">
                        <p>
                            <strong>{address.title}</strong>
                        </p>
                        <p>{address.detailedAddress}</p>
                        <p>
                            {address.wardId?.wardName}, {address.districtId?.districtName}, {address.provinceId?.provinceName}
                        </p>
                        {address.isDefault && <p className="default-label">[Mặc định]</p>}
                        <button
                            className="btn btn-warning btn-sm"
                            onClick={() => handleOpenModal(address)}
                        >
                            Sửa
                        </button>
                        <button
                            className="btn btn-danger btn-sm"
                            onClick={() => handleDeleteAddress(address._id)}
                        >
                            Xóa
                        </button>
                        {!address.isDefault && (
                            <button
                                className="btn btn-primary btn-sm"
                                onClick={() => handleSetDefaultAddress(address._id)}
                            >
                                Đặt làm mặc định
                            </button>
                        )}
                    </div>
                ))}
            </div>

            <button className="btn btn-success mt-3" onClick={() => handleOpenModal()}>
                Thêm Địa Chỉ Mới
            </button>

            {/* Modal for adding/editing address */}
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{editingAddressId ? "Sửa Địa Chỉ" : "Thêm Địa Chỉ"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        <label>Tiêu đề:</label>
                        <input
                            type="text"
                            name="title"
                            value={newAddress.title}
                            onChange={handleInputChange}
                            className="form-control"
                        />
                    </div>
                    <LocationSelector
                        onChange={(location) => {
                            setNewAddress((prev) => ({
                                ...prev,
                                provinceId: location.provinceId,
                                districtId: location.districtId,
                                wardId: location.wardId,
                            }));
                        }}
                        defaultValues={{
                            provinceId: newAddress.provinceId,
                            districtId: newAddress.districtId,
                            wardId: newAddress.wardId,
                        }}
                    />
                    <div className="form-group">
                        <label>Địa chỉ chi tiết:</label>
                        <textarea
                            name="detailedAddress"
                            value={newAddress.detailedAddress}
                            onChange={handleInputChange}
                            className="form-control"
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Hủy
                    </Button>
                    <Button variant="primary" onClick={handleSaveAddress}>
                        Lưu
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default AddressBook;
